import UnfilledButton from "@/components/common/unfilled-button";
import styles from "./styles/confirm-delete-modal.module.scss";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import { useState } from "react";

type ConfirmDeleteModalProps = {
  deleteItemName: string;
  deletionCallback: () => Promise<void>;
};

const ConfirmDeleteModal = ({
  deleteItemName,
  deletionCallback,
}: ConfirmDeleteModalProps) => {
  const { hideModal } = useGlobalModalContext();
  const [isDisabled, setIsDisabled] = useState<boolean>(false);

  return (
    <div className={styles.modal_wrapper}>
      <div className={styles.text_wrapper}>
        <div className={styles.top_text}>
          {deleteItemName} will be permanently
          <div className={styles.deleted_text}>deleted</div>
        </div>
        <div className={styles.bottom_text}>
          Are you sure you wish to proceed?
        </div>
      </div>
      <div className={styles.buttons_wrapper}>
        <UnfilledButton
          disabled={isDisabled}
          text={"CANCEL"}
          onClick={hideModal}
          borderColor={"#F9A825"}
        />
        <UnfilledButton
          disabled={isDisabled}
          text={"DELETE"}
          onClick={async () => {
            setIsDisabled(true);
            try {
              await deletionCallback();
            } finally {
              setIsDisabled(false);
            }
          }}
        />
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
